import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=745c7192&scoped=true"
import script from "./OptionCard.vue?vue&type=script&lang=js"
export * from "./OptionCard.vue?vue&type=script&lang=js"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=745c7192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c7192",
  null
  
)

export default component.exports